import { useState } from 'react';

import { ApolloError } from '@apollo/client';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

import IconButton from '../IconButton';
import CloseIcon from '../../assets/imgs/icon/close.svg';
import Flex from '../Flex';

export const ErrorMessage = ({
	error = {},
	apolloError,
	message,
	dismissible = true
}: ErrorProps): JSX.Element => {
	const [show, setShow] = useState(true);
	const { data: errorData, status } = error as FetchBaseQueryError;

	const errorMessage = message
		? message
		: apolloError
			? (apolloError.message as string)
			: status && typeof status !== 'number'
				? "It looks like we couldn't reach our servers. Please try again later."
				: errorData && typeof errorData === 'string' // check if fetchError
					? (errorData as string)
					: errorData &&
						  typeof errorData === 'object' &&
						  Object.prototype.hasOwnProperty.call(
								errorData,
								'user_message'
						  ) // check if DRF Error
						? (errorData as DRFError).user_message
						: errorData &&
							  typeof errorData === 'object' &&
							  Object.prototype.hasOwnProperty.call(
									errorData,
									'detail'
							  )
							? (errorData as DjangoError).detail // check if Django Error
							: "We weren't able to complete this task. Please try again later."; // default case, code error/server is not available
	return (
		<>
			{show && (
				<Flex
					$flexDirection="row"
					$alignItems="center"
					$padding="12px"
					$margin="0 0 12px 0"
					$height="auto"
					$placeContent="center space-between"
					className="alert alert-danger"
				>
					<strong>{errorMessage}</strong>
					{dismissible && (
						<IconButton
							onClick={() => setShow(false)}
							width={12}
							height={12}
							url={CloseIcon}
							alt={'close'}
						></IconButton>
					)}
				</Flex>
			)}
		</>
	);
};

interface ErrorProps {
	error?: FetchBaseQueryError | SerializedError | DjangoError;
	apolloError?: ApolloError;
	message?: string | null;
	dismissible?: boolean;
}

type DRFError = {
	developer_message: string;
	user_message: string;
	error_code: number;
	info_url: string;
};

type DjangoError = {
	detail: string;
};
